module.exports = __webpack_public_path__ + "img/GallerySample2.8852359f.jpg";